import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7a122886 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _ed480b04 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _9fd136be = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _5904cd5d = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _786209fd = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _19e9edd9 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _07b2a8d7 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _27efc7f2 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _e6e6500a = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _777d3e1c = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _1b6565f0 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _557fbea0 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _72a07d26 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _525d207d = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _51428d96 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _2da556e0 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _9ecb3472 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _2bbb403d = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _2308447e = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _244b93de = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _56d05de7 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _65788fd6 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _ad9255ee = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _8ece5078 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _2d9fbf8a = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _347af1db = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _6b995fdd = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _4eb23cc5 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _beae483a = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _ec6d1936 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _22e2699c = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _5d277e1e = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _33ea0e38 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _92f98220 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _7e7bd5b2 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _78012ef2 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _0136160d = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _6809fc51 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _5ee6d14d = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _3ec78f03 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _13c0eafa = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _52e76ecf = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _07e2b410 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _61821dc6 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _634de640 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _6d303728 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _92ab9fd4 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _f8d0e7a0 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _6b35f338 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _5ae49c88 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _555c6743 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _46e5778b = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _4e67e374 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _2e225d66 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _61c41899 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _71aab804 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _745f1965 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _084a43da = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _2e87e9cb = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _c46efe94 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _121ba29a = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _44c2ac6d = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _5ed382c0 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _62b43d58 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _81079096 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _16fc946e = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _5c6fc96e = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _a1b0fd4e = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _73f467a5 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _1052c5ba = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _17f42458 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _8e3de0d4 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _16eeaf6a = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _19688658 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _02425120 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _85a62df0 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _7a122886,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _ed480b04,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _9fd136be,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _5904cd5d,
    name: "calendar"
  }, {
    path: "/customer",
    component: _786209fd,
    name: "customer"
  }, {
    path: "/details",
    component: _19e9edd9,
    name: "details"
  }, {
    path: "/goals",
    component: _07b2a8d7,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _27efc7f2,
    name: "maisoku"
  }, {
    path: "/media",
    component: _e6e6500a,
    name: "media"
  }, {
    path: "/privacy",
    component: _777d3e1c,
    name: "privacy"
  }, {
    path: "/project",
    component: _1b6565f0,
    name: "project"
  }, {
    path: "/response",
    component: _557fbea0,
    name: "response"
  }, {
    path: "/sale",
    component: _72a07d26,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _525d207d,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _51428d96,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _2da556e0,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _9ecb3472,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _2bbb403d,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _2308447e,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _244b93de,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _56d05de7,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _65788fd6,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _ad9255ee,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _8ece5078,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _2d9fbf8a,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _347af1db,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _6b995fdd,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _4eb23cc5,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _beae483a,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _ec6d1936,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _22e2699c,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _5d277e1e,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _33ea0e38,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _92f98220,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _7e7bd5b2,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _78012ef2,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _0136160d,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _6809fc51,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _5ee6d14d,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _3ec78f03,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _13c0eafa,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _52e76ecf,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _07e2b410,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _61821dc6,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _634de640,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _6d303728,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _92ab9fd4,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _f8d0e7a0,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _6b35f338,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _5ae49c88,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _555c6743,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _46e5778b,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _4e67e374,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _2e225d66,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _61c41899,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _71aab804,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _745f1965,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _084a43da,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _2e87e9cb,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _c46efe94,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _121ba29a,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _44c2ac6d,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _5ed382c0,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _62b43d58,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _81079096,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _16fc946e,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _5c6fc96e,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _a1b0fd4e,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _73f467a5,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _1052c5ba,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _17f42458,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _8e3de0d4,
    name: "property-property",
    children: [{
      path: "contact",
      component: _16eeaf6a,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _19688658,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _02425120,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _85a62df0,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
